import { Component, Fragment } from 'react';

import Portal from 'Lib/components/common/Portal';

import './fullScreenModal.scss';

export class FullScreenModalHeader extends Component {
    renderCommand() {
        if (this.props.renderCommand) {
            return this.renderCommand();
        }
        return this.props.children;
    }

    onClose = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    render() {
        const { showClose = false } = this.props;

        return (
            <div className="fullscreen-modal-header">
                {showClose ? (
                    <div className="fullscreen-modal-header-toggle">
                        <span className="handle" onClick={this.onClose}>
                            <i className="fal fa-times"></i>
                            <span className="sr-only">Close</span>
                        </span>
                        <span className="separator"></span>
                    </div>
                ) : null}
                <div className="fullscreen-modal-header-title">{this.props.title}</div>
                <div className="fullscreen-modal-header-command">{this.renderCommand()}</div>
            </div>
        );
    }
}

export class FullScreenModalBody extends Component {
    render() {
        return <div className="fullscreen-modal-body">{this.props.render ? this.props.render() : this.props.children}</div>;
    }
}

export class FullScreenModalFooter extends Component {
    render() {
        return <div className="fullscreen-modal-footer">{this.props.render ? this.props.render() : this.props.children}</div>;
    }
}

export class FullScreenModal extends Component {
    onToggle = () => {};

    render() {
        const { isOpen, isLoading, loadingText = 'Loading...' } = this.props;

        if (!isOpen) {
            return null;
        }

        return (
            <Portal>
                <div className="fullscreen-modal-wrapper">
                    <div className="fullscreen-modal">
                        {isLoading ? (
                            <div className="fullscreen-modal-loading">
                                <div>
                                    <div>
                                        <i className="fa fa-spinner-third fa-5x fa-spin" aria-hidden="true"></i>
                                    </div>
                                    <br />
                                    {loadingText}
                                </div>
                            </div>
                        ) : (
                            this.props.children
                        )}
                    </div>
                </div>
            </Portal>
        );
    }

    renderTitle() {
        if (this.props.renderTitle) {
            return this.props.renderTitle();
        }

        return <div>{this.props.title}</div>;
    }

    renderBody() {
        if (this.props.render) {
            return this.props.render({
                props: this.props,
                state: this.state
            });
        }

        return this.props.children;
    }

    renderCommand() {
        if (this.props.renderCommand) {
            return this.props.renderCommand({
                ...this.props
            });
        }
    }
}

export default FullScreenModal;
